import React, {Component} from "react";
import {Alert, Button, Col, ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import {Link, withRouter} from "react-router-dom";
import {AvCheckbox, AvCheckboxGroup, AvForm} from "availity-reactstrap-validation";
import {getAccountAlias} from "../../helpers/Util";
import SweetAlert from "react-bootstrap-sweetalert";
import {connect} from "react-redux";
import {
    deleteDelegatees,
    getDelegatee,
    getProfile,
    updateDelegatees,
    updateDelegateesResponse
} from "../../store/auth/user/actions";
import {withNamespaces} from "react-i18next";
import {updateDelegateePermissions} from "../../helpers/auth";
import {ReactMultiEmail} from "react-multi-email";
import "react-multi-email/dist/style.css";

class CardDelegates extends Component{
    constructor(props) {
        super(props);
        this.delegateeForm = React.createRef();
        this.state = {
            newDelegatees: null,
            newDelegatee: false,
            delDelegatee: null,
            curDelegatee: null,
            curFormValues: null,
            onSubmit: false
        };
        this.setCurDelegatee = this.setCurDelegatee.bind(this);
        this.handleDeleteDelegatee = this.handleDeleteDelegatee.bind(this);
        this.handleUpdateDelegateePermissions = this.handleUpdateDelegateePermissions.bind(this);
        this.handleDelegateeSubmit = this.handleDelegateeSubmit.bind(this);
    }

    handleDelegateeSubmit(e, val) {
        this.props.updateDelegatees(this.state.newDelegatees, this.props.history);
        this.setState({newDelegatees: null, onSubmit: false});
    }

    setCurDelegatee = (d) => {
        const formvalues = {};
        if (d) {
            if (d.permissions) {
                const permissions = typeof d.permissions === "string" ? JSON.parse(d.permissions) : d.permissions;
                permissions && Object.entries(permissions).forEach(p => formvalues[p[0]] = Object.entries(p[1]).map(i => i[1] ? i[0] : null).filter(i => i));
            } else {
                this.props.profile && this.props.profile.defaultDelegatedPermissions && Object.entries(this.props.profile.defaultDelegatedPermissions).forEach(p => {
                    formvalues[p[0]] = Object.entries(p[1]).map(i => i[1] ? i[0] : null).filter(i => i);
                });
            }
        }
        this.setState({
            curDelegatee: d,
            newDelegatee: null,
            curFormValues: d ? formvalues : null,
            onSubmit: false
        });
        this.props.updateDelegateesResponse(null);
    };

    handleDeleteDelegatee(ids) {
        const res = this.props.deleteDelegatees(ids, this.props.history);
        if (res) {
            this.props.getDelegatee();
        }
        this.setState({delDelegatee: null, newDelegatees: null,  onSubmit: false});
    }

    handleUpdateDelegateePermissions(e, val) {
        const permissions = {};
        val && Object.entries(val).forEach(v => {
            if (v[1] && v[1].length > 0) {
                if (!permissions[v[0]]) permissions[v[0]] = {};
                v[1].map(i => permissions[v[0]][i] = true);
            }
        });
        updateDelegateePermissions(this.state.curDelegatee.id, {permissions}).then(res => {
            if (res) {
                this.props.getDelegatee();
            }
        }).then(() => {
            this.setCurDelegatee(null);
        });
    }

    intersectPermissions(permissions){
        const TMDefaultPermissions = {
            ria: {
                view: true,
                create: true,
                modify: true,
                delete: true,
                manage: true
            },
            agent: {
                view: true,
                create: true,
                modify: true,
                delete: true,
                manage: true
            },
            client: {
                view: true,
                create: true,
                modify: true,
                delete: true,
                manage: true
            },
            trade: {
                view: true,
                execute: true,
                deposit: false,
                withdraw: true,
                whitelist: true,
                stake: false,
                unstake: false,
                redelegate: false,
                claim: false
            },
            balance: {
                view: true
            },
            tokenManagement: {
                view: true,
                create: true,
                delete: true,
                tax: true
            }
        };
        const unionPermissions = {};
        Object.entries(permissions).forEach(p => {
            if (Object.hasOwn(TMDefaultPermissions, p[0])) {
                unionPermissions[p[0]] = {};
                Object.entries(p[1]).forEach(f=> {
                    if (Object.hasOwn(TMDefaultPermissions[p[0]], f[0])) {
                        unionPermissions[p[0]][f[0]] = permissions[p[0]][f[0]];
                    }
                });
            }
        });
        return unionPermissions;
    }

    render() {
        const {profile, delegatees, delegateesResponse, toggleDelegateModal, manageDelegateeModal} = this.props;
        const {
            newDelegatees,
            curDelegatee,
            newDelegatee,
            curFormValues,
            delDelegatee,
            onSubmit
        } = this.state;
        const isTokenManagement = this.props.env.VARIANT === "TOKEN_MGMT";
        const permissions = profile?.defaultDelegatedPermissions && (isTokenManagement ? this.intersectPermissions(profile.defaultDelegatedPermissions) : profile.defaultDelegatedPermissions);
        return(
            <Modal isOpen={manageDelegateeModal} role="dialog" size={curDelegatee || newDelegatee ? "lg" : "md"}
                                      autoFocus={true} centered>
            <div className={"modal-content"}>
                <ModalHeader toggle={curDelegatee || newDelegatee ?
                    (() => this.setCurDelegatee(null)) : toggleDelegateModal}>
                    {(curDelegatee || newDelegatee) ? newDelegatee ? "New Delegatees" : `Grant Permissions For ${curDelegatee.delegatee}` : "Manage Delegatees"}
                </ModalHeader>
                <ModalBody>
                    {/* Alert */}
                    {delegateesResponse ? (delegateesResponse.success ?
                        <Alert color="success">
                            {delegateesResponse.data.added && delegateesResponse.data.added.length > 0 &&
                                <p>{`Users granted access: ${delegateesResponse.data.added.map(d => d.delegatee).join(", ")}`}</p>}
                            {delegateesResponse.data.invited && delegateesResponse.data.invited.length > 0 &&
                                <p>{`New users invited: ${delegateesResponse.data.invited.join(", ")}`}</p>}
                        </Alert> :
                        <Alert color="danger">{delegateesResponse.error.message}</Alert>) : ""}
                    {!curDelegatee && !newDelegatee ? (
                        // List of delegate
                        <ListGroup>
                            {delegatees && delegatees.length > 0 ? delegatees.map(d => (
                                <ListGroupItem key={d.delegatee}>
                                    {d.delegatee}
                                    <span className="float-right">
                                                    <Link to="#" onClick={() => this.setCurDelegatee(d)}>Edit</Link>
                                                    <Link to="#" className="ml-2"
                                                          onClick={() => this.setState({delDelegatee: d})}>Delete</Link>
                                                </span>
                                </ListGroupItem>
                            )) : <ListGroupItem>No delegatees.</ListGroupItem>}
                        </ListGroup>) :
                        (<Row>
                            <Col className="px-5">
                                <ListGroup>
                                    {newDelegatee ?
                                        // Form of add new delegate
                                        <div className={"mt-1"}>
                                            <ReactMultiEmail
                                                style={{
                                                    height: "100px"
                                                }}
                                                placeholder="Enter delegatee email(s)"
                                                onChange={(emails) => {
                                                    this.setState({newDelegatees: emails});
                                                }}
                                                autoFocus={true}
                                                getLabel={(email, index, removeEmail) => {
                                                    return (
                                                        <div data-tag key={index}>
                                                            <div data-tag-item>{email}</div>
                                                            <span data-tag-handle onClick={() => removeEmail(index)}>
                                                                ×
                                                            </span>
                                                        </div>
                                                    );
                                                }}
                                            />
                                            <div className="mt-4">
                                                <Button color={"primary"} block onClick={()=>{
                                                    this.setState({
                                                        onSubmit: true
                                                    });
                                                }}>
                                                    Submit
                                                </Button>
                                            </div>
                                        </div>
                                        :
                                        // Change permissions of delegate
                                        (profile && permissions &&
                                            <AvForm ref={this.delegateeForm} model={curFormValues}
                                                    onValidSubmit={this.handleUpdateDelegateePermissions}>
                                                <div className={"mt-1 mb-3"}>
                                                    Please select the permissions you would like to grant to {curDelegatee.delegatee}. By default permissions are set to view-only.
                                                </div>
                                                {Object.entries(permissions).map(p => (
                                                    <ListGroupItem key={p[0]}>
                                                        <AvCheckboxGroup className="px-2 my-0" name={p[0]}
                                                                         label={getAccountAlias(p[0])}>
                                                            <Row xl={12} className="mb-2">
                                                                {Object.entries(p[1]).map(i => (
                                                                    <Col xl={2} className={"mb-2"}
                                                                         key={p[0] + "-" + i[0]}>
                                                                        <AvCheckbox label={i[0]} value={i[0]}/>
                                                                    </Col>))}
                                                            </Row>
                                                        </AvCheckboxGroup>
                                                    </ListGroupItem>))}
                                                <div className="mt-4">
                                                    <Button color={"primary"} block>
                                                        Submit
                                                    </Button>
                                                </div>
                                            </AvForm>)}
                                </ListGroup>
                            </Col>
                        </Row>)
                    }
                    {!(curDelegatee || newDelegatee) &&
                        (<div className="mt-4">
                            <Button type={"button"} color={"primary"} block
                                    onClick={() => this.setState({newDelegatee: true})}>
                                Add a new delegatee
                            </Button>
                            {delegatees && delegatees.length > 0 &&
                                <Button type={"button"} color={"danger"} block
                                        onClick={() => this.setState({newDelegatees: [], onSubmit: true})}>
                                    Delete all delegatees
                                </Button>}
                        </div>)
                    }

                </ModalBody>
            </div>
            {delDelegatee && <SweetAlert info showCancel title={"Are you sure?"}
                                         onCancel={() => this.setState({delDelegatee: null})}
                                         onConfirm={() => this.handleDeleteDelegatee([delDelegatee.id])}>
                <div className="my-1">
                    Remove Delegatee {delDelegatee.delegatee}
                </div>
            </SweetAlert>}
            {onSubmit && newDelegatees && (newDelegatees.length > 0 ?
                <SweetAlert info showCancel title={"Are you sure?"}
                            closeOnClickOutside={false}
                            onCancel={() => this.setState({onSubmit: false})}
                            onConfirm={() => this.handleDelegateeSubmit()}>
                    <div className="my-1">
                        Give access to <br/> {newDelegatees.join(", ")}
                    </div>
                </SweetAlert> :
                <SweetAlert warning showCancel title={"Are you sure?"}
                            closeOnClickOutside={false}
                            onCancel={() => this.setState({onSubmit: false})}
                            onConfirm={() => this.handleDeleteDelegatee(delegatees.map(d => d.id))}>
                    Remove all delegatees?
                </SweetAlert>)
            }
        </Modal>);

    }
}

const mapStateToProps = state => {
    const {user, profile, delegators, delegatees, delegateesResponse} = state.User;
    const {env} = state.Variables;
    return {user, profile, delegators, delegatees, delegateesResponse, env};
};

export default withRouter(connect(mapStateToProps, {
    getDelegatee,
    updateDelegatees,
    deleteDelegatees,
    updateDelegateesResponse,
    getProfile,
})(withNamespaces()(CardDelegates)));
